import { Col } from "react-bootstrap";

export const ProjectCard = ({ title, description, imageUrl ,url}) => {
  return (
    <Col size={12} sm={6} md={4}>
      <div className="proj-imgbx">
      <a href={url} target="_blank"  rel="noreferrer">
       
        <img alt="ggg"src={imageUrl} />
        
        <div  >
          <h4>{title}</h4>
          <span>{description}</span>
        </div>
        </a>
      </div>
    </Col>
  )
}
